import {Component, OnInit} from '@angular/core';
import {LanguageService} from './services/languages/language.service';
import {Router} from '@angular/router';

import {BaseHttpService} from './services/base-http/base-http.service';
import {DataService} from './shared/services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  static language = 'bg';
  
  isMenuHidden: boolean;
  selectedMainMenu: string;
  selectedDropMenuOption: string;
  commentsVisible: boolean;
  
  constructor(
    public languageService: LanguageService,
    public httpService: BaseHttpService,
    private router: Router,
    private data: DataService
  ) {
  }
  
  ngOnInit() {
    this.data.currentComments.subscribe(comments => this.commentsVisible = comments);
  }
  
  public clickOnMainMenu(menu: string, dropMenuOption: string = ''): void {
    if (
      this.selectedMainMenu !== menu ||
      this.selectedDropMenuOption !== dropMenuOption
    ) {
      this.httpService.selectedFilteredPageIndex = 1;
    }
    if (dropMenuOption === '') {
      this.hideMobileMenu();
    } else if (
      this.selectedMainMenu === menu && this.selectedDropMenuOption !== dropMenuOption
    ) {
      this.hideMobileMenu();
    }
    this.selectedMainMenu = menu;
    this.selectedDropMenuOption = dropMenuOption;
  }
  
  public hideMobileMenu(): void {
    this.isMenuHidden = true;
  }
}
